import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_USER_DETAIL_QUERY_KEY, USER } from "../types/CommonTypes";

async function getUserDetail(params?: {
  tenantId?: string;
  hospitalId?: string;
  userId?: string;
  loginUserId?: string;
}): Promise<USER> {
  const { userId, tenantId, hospitalId, loginUserId } = params ?? {};
  const { data } = await fetcher({
    url: `users/user/${userId}`,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
      "x-user-id": loginUserId??userId,
    },
  });
  return data;
}

function useGetUserDetailQuery(params?: {
  tenantId?: string;
  hospitalId?: string;
  userId?: string;
  loginUserId?: string;
}) {
  const { userId, tenantId, hospitalId, loginUserId } = params ?? {};
  return useQuery({
    queryKey: [GET_USER_DETAIL_QUERY_KEY, userId, tenantId, hospitalId, loginUserId],
    queryFn: () => getUserDetail(params),
    enabled: !!userId && !!tenantId && !!hospitalId,
  });
}

export default useGetUserDetailQuery;
